import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_2 = { class: "col-span-12 xl:col-span-3 lg:col-span-4 md:col-span-6" }
const _hoisted_3 = { class: "col-span-12 xl:col-span-3 lg:col-span-4 md:col-span-6" }
const _hoisted_4 = { class: "col-span-12 xl:col-span-3 lg:col-span-4 md:col-span-6" }
const _hoisted_5 = { class: "col-span-12 xl:col-span-3 lg:col-span-4 md:col-span-6" }
const _hoisted_6 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Sex "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_8 = { class: "flex items-center md:pt-5 pt-2 space-x-6" }
const _hoisted_9 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_10 = {
  key: 0,
  class: "col-span-12 lg:col-span-4 md:col-span-6"
}
const _hoisted_11 = { class: "flex flex-col flex-wrap justify-between col-span-12 gap-3 lg:col-span-4 md:col-span-6" }
const _hoisted_12 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600",
  id: "email-error"
}
const _hoisted_13 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_14 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_15 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "Employed?", -1)
const _hoisted_17 = { class: "flex flex-wrap mt-5 space-x-5" }
const _hoisted_18 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "OFW?", -1)
const _hoisted_20 = { class: "flex flex-wrap mt-5 space-x-5" }
const _hoisted_21 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_22 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_23 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_24 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_25 = { class: "col-span-12" }
const _hoisted_26 = { class: "col-span-12 md:col-span-6" }
const _hoisted_27 = { class: "col-span-12 md:col-span-6" }
const _hoisted_28 = { class: "col-span-12" }

import TextInput from "@/components/inputs/TextInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import { ref, watch } from 'vue';
import { BirthdayClassification } from "@/views/enums/BirthdayClassification";
import UserBirthdateAge from '@/components/forms/UserBirthdateAge.vue'
import { numberonly } from "@/components/composables/useNumberOnly";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  props: {
	form: {
		type: Object,
		required:true,
	},
	errors: {
		type: Object,
		required:true,
	},
	optionRelationChild: {
		type: Object,
		required:true,
	},
	optionBirthday: {
		type: Object,
		required:true,
	},
	optionSelected: {
		type: Object,
		required:true,
	},
	optionCivilStatus: {
		type: Object,
		required:true,
	},
	optionYerOrNo: {
		type: Object,
		required:true,
	},
	optionEducationAttain: {
		type: Object,
		required:true,
	},
	optionHousingClass: {
		type: Object,
		required:true,
	},
	optionGenders: {
		type: Object,
		required:true,
	}
},
  setup(__props, { expose: __expose }) {

const props = __props

const formData = ref({ ...props.form });

const removeAddRelatedTypes = (item:number): void => {
	const index = formData.value.person_related_types.indexOf(item)

	if(index > -1){
		formData.value.person_related_types.splice(index, 1);
	} else {
		formData.value.person_related_types.push(item);
	}
} 

__expose({
	formData
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TextInput, {
        label: "Last Name",
        placeholder: "Last Name",
        name: "last_name",
        id: "last_name",
        required: "",
        modelValue: formData.value.last_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.last_name) = $event)),
        error: __props.errors?.last_name
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TextInput, {
        label: "First Name",
        placeholder: "First Name",
        name: "first_name",
        id: "first_name",
        required: "",
        modelValue: formData.value.first_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.first_name) = $event)),
        error: __props.errors?.first_name
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TextInput, {
        label: "Middle Name",
        placeholder: "Middle Name",
        name: "middle_name",
        id: "middle_name",
        modelValue: formData.value.middle_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.middle_name) = $event)),
        error: __props.errors?.middle_name
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(RadioGroup, {
            options: __props.optionGenders,
            name: "gender",
            required: "",
            modelValue: formData.value.gender,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.gender) = $event)),
            error: __props.errors?.gender
          }, null, 8, ["options", "modelValue", "error"])
        ]),
        (__props.errors?.gender)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["text-[10px] mt-1", __props.errors?.gender ? 'text-red-600' : 'text-gray-800']),
              id: "email-error"
            }, _toDisplayString(__props.errors?.gender), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.optionRelationChild,
        label: "Relationship to the child",
        id: "companion_relationship_id",
        name: "relation_child",
        placeholder: "Select..",
        modelValue: formData.value.companion_relationship_id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.companion_relationship_id) = $event)),
        error: __props.errors?.companion_relationship_id,
        required: ""
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    (formData.value.relationship_child === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(TextInput, {
            label: "Other, please specify",
            placeholder: "Other, please specify",
            name: "other_specify",
            id: "specify_relationship_child",
            modelValue: formData.value.specify_relationship_child,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.specify_relationship_child) = $event)),
            error: __props.errors?.specify_relationship_child
          }, null, 8, ["modelValue", "error"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(UserBirthdateAge, {
      form: formData.value,
      errors: __props.errors,
      customClass: "md:col-span-6 col-span-12"
    }, null, 8, ["form", "errors"]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.optionSelected, (option, index) => {
        return (_openBlock(), _createBlock(CheckboxInput, {
          key: index,
          id: option.id,
          name: option.name,
          label: option.label,
          checked: formData.value.person_related_types.indexOf(option.id) > -1,
          onClick: ($event: any) => (removeAddRelatedTypes(option.id))
        }, null, 8, ["id", "name", "label", "checked", "onClick"]))
      }), 128)),
      (__props.errors?.person_related_types)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(__props.errors?.person_related_types), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.optionCivilStatus,
        label: "Civil Status",
        id: "civil_status_id",
        name: "civil_status",
        placeholder: "Select..",
        modelValue: formData.value.civil_status_id,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.civil_status_id) = $event)),
        error: __props.errors?.civil_status_id
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(TextInput, {
        type: "tel",
        label: "Contact Number",
        placeholder: "Contact number",
        name: "contact_number",
        id: "contacts",
        add_on_left: true,
        add_on_text: "+63",
        maxlength: 10,
        onKeypress: _unref(numberonly),
        modelValue: formData.value.contacts,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.contacts) = $event)),
        error: __props.errors?.contacts
      }, null, 8, ["onKeypress", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createVNode(RadioGroup, {
          id: "is_employed",
          options: __props.optionYerOrNo,
          name: "employed",
          modelValue: formData.value.is_employed,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.is_employed) = $event)),
          error: __props.errors?.is_employed
        }, null, 8, ["options", "modelValue", "error"])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createVNode(RadioGroup, {
          id: "is_ofw",
          options: __props.optionYerOrNo,
          name: "ofw",
          modelValue: formData.value.is_ofw,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((formData.value.is_ofw) = $event)),
            _cache[10] || (_cache[10] = value => (formData.value.is_ofw = value))
          ],
          error: __props.errors?.is_ofw
        }, null, 8, ["options", "modelValue", "error"])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(TextInput, {
        label: "Occupation",
        placeholder: "Occupation",
        name: "occupation",
        id: "occupation",
        modelValue: formData.value.occupation,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.occupation) = $event)),
        error: __props.errors?.occupation
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(TextInput, {
        label: "Company",
        placeholder: "Company",
        name: "company",
        id: "company",
        modelValue: formData.value.company,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.company) = $event)),
        error: __props.errors?.company
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(TextInput, {
        label: "Weekly Income",
        placeholder: "Weekly Income",
        name: "weekly_income",
        id: "weekly_income",
        modelValue: formData.value.weekly_income,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.weekly_income) = $event)),
        error: __props.errors?.weekly_income
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(TextInput, {
        label: "Other source of income",
        placeholder: "Other source of income",
        name: "other_source_income",
        id: "other_source_of_income",
        modelValue: formData.value.other_source_of_income,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.other_source_of_income) = $event)),
        error: __props.errors?.other_source_of_income
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(CheckboxInput, {
        id: "is_enrolled_in_school",
        name: "enrolled_school",
        label: "Enrolled in school",
        checked: formData.value.is_enrolled_in_school,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = (value) => (formData.value.is_enrolled_in_school = value))
      }, null, 8, ["checked"])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.optionEducationAttain,
        label: "Educational Attainment",
        id: "educational_attainment_id",
        name: "education_attainment",
        placeholder: "Select..",
        modelValue: formData.value.educational_attainment_id,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.educational_attainment_id) = $event)),
        error: __props.errors?.educational_attainment_id
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(TextInput, {
        label: "School",
        placeholder: "School",
        name: "school",
        id: "school",
        modelValue: formData.value.school,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.school) = $event)),
        error: __props.errors?.school
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(TextInput, {
        textarea: "",
        label: "Other information",
        placeholder: "Other information",
        name: "other_information",
        id: "other_information",
        modelValue: formData.value.other_information,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.other_information) = $event)),
        error: __props.errors?.other_information
      }, null, 8, ["modelValue", "error"])
    ])
  ]))
}
}

})